import axios from 'axios';
import { config } from '@biproxi/env';

const deletePaymentSourceMutation = async (paymentSourceId: string) => {
  const res = await axios.post('/api/billing/delete-payment-source', { paymentSourceId }, {
    headers: {
      Authorization: config.CHARGEBEE_KEY,
    },
  });
  const result = await res.data;
  return result;
};

export default deletePaymentSourceMutation;
